import { ArrayPick } from "@hex-insights/core";
import { AcademicYear, AcademicYearNameFragment } from "../../../Utilities";
import { AcademicYearUtilities } from "../../Utilities";
import * as AcademicTermFormat from "../AcademicTerm";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: AcademicYearNameFragment) {
	return Fields.name(instance.name);
}

export function status(instance: { academicTerms: ArrayPick<AcademicYear["academicTerms"], "startDate" | "endDate"> }) {
	const { startDate, endDate } = AcademicYearUtilities.getDateBounds(instance);
	if (!(startDate && endDate)) {
		return "No Terms";
	}
	return AcademicTermFormat.status({ startDate, endDate });
}
